// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
//   Accordion,
// } from "react-bootstrap";


// const faqData = [
//     {
//         q: "1. What is meant by the SCOMET item?",
//         a: (
//             <p>
//                 SCOMET is an acronym for Special Chemicals, Organisms, Materials, Equipment, and Technologies. This list includes goods that are considered dual-use items, which means they have both civil and military applications and can potentially be used as weapons of mass destruction. SCOMET items include goods, technology, chemicals, and organisms, among others.
//             </p>
//         ),
//     },
//   {
//     q:
//           "2. What are the SCOMET categories?",
//       a: (
//       <>
//         <p>"The SCOMET items are classified into 9 distinct categories:</p>
//         <ul>
//           <li>Category 1: Nuclear materials, nuclear-related materials, equipment, and technology</li>
//           <li>
//                       Category 2: Toxic chemical agents and other chemicals</li>
//                   <li>Category 3: Micro-organisms, toxins</li>
//                   <li>Category 4: Materials, materials processing equipment, and related technologies</li>
//                   <li>Category 5: Nuclear-related other equipment and technology, not controlled under Category 1</li>
//                   <li>Category 6: Aerospace systems, equipment including production and test equipment, related technology, and specially designed components and accessories thereof</li>
//                   <li>Category 7: Munitions list</li>
//                   <li>Category 8: Reserved</li>
//                   <li> Category 9: Special materials and related equipment, material processing, electronics, computers, telecommunications, information security, sensors and lasers, navigation and avionics, marine, aerospace, and propulsion.</li>
//                   <p>It should be noted that the SCOMET list also includes used items falling under the list, non-controlled items containing one or more controlled component(s) where the controlled component(s) is the principal element, as well as technology required for the development, production, or use of items controlled under Category 8 of the SCOMET items."</p>
//         </ul>
//       </>
//     ),
//   },
//  {
//      q: "3. What are the consequences of exporting SCOMET items without an authorization?",
//              a: (
//          <p>If any SCOMET items are exported without proper authorization, penalties under the Foreign Trade (Development and Regulation) Act (FTDR) may be imposed. These penalties can include monetary fines and even imprisonment in some cases. The FTDR Act provides a legal framework for regulating the import and export of goods, including SCOMET items, to protect national security interests and prevent their misuse. It is, therefore, important to comply with all relevant provisions of the FTDR Act and obtain the necessary authorizations before exporting any SCOMET items.</p>
//      ),
//     },
//  {
//         q: "4. Who requires SCOMET authorization?",
//         a: (
//             <p>
//                 Any person, company, or organization involved in the export, import, or transit of SCOMET items from or to India requires SCOMET authorization. This includes manufacturers, traders, exporters, importers, freight forwarders, and carriers involved in the transportation of SCOMET items.
//          </p>
//      ),
//   },
//   {
//       q: "5. Are there any exemptions to SCOMET authorization?",
      
//         a: (
//             <p>Yes, there are certain exemptions to SCOMET authorization. For example, SCOMET items that are exclusively for military use by the Indian Armed Forces, items for United Nations peacekeeping missions, or items for use in bona fide research and development programs may be exempted from SCOMET authorization. However, these exemptions are subject to specific conditions and requirements, and it is essential to verify the eligibility for exemption before exporting, importing, or transiting SCOMET items.</p>
//         ),
//   },
//   {
//         q: "6. What are the penalties for non-compliance with SCOMET authorization?",
//         a: (
//             <p>Non-compliance with SCOMET authorization can result in severe penalties, including fines, imprisonment, and cancellation of authorization. In addition, the unauthorized export, import, or transit of SCOMET items can have serious legal and reputational consequences, including sanctions and restrictions on trade and business activities.</p>
//         ),
//   },
//   {
//         q: "7. How long does it take to obtain SCOMET authorization?",
//         a: (
//             <p>The timeline for obtaining SCOMET authorization may vary depending on the complexity of the application, the completeness of the documentation, and the review process. However, as per the standard guidelines, the competent authority aims to process SCOMET applications within 60 days from the date of receipt of a complete application. However, the actual time taken may vary, and it is advisable to plan ahead and submit the application well in advance of the intended export, import, or transit.</p>
//         ),
//   },
//   {
//         q: "8. Can SCOMET authorization be transferred or amended?",
//         a: (
//             <p>SCOMET authorization is not transferable and is valid only for the authorized party, end- use, and end-user as mentioned in the authorization. Any change in the authorized party, end-use, or end-user requires an amendment to the authorization, which must be obtained from the competent authority before proceeding with the export, import, or transit of SCOMET items.</p>
//         ),
//   },
//   {
//         q: "9. What are the reporting requirements under SCOMET authorization?",
//         a: (
//             <p>SCOMET authorization holders are required</p>
//         ),
//     },
//   {
//         q: "10. What are the criteria for SCOMET authorization?",
//         a: (
//             <p>SCOMET authorization is granted based on various criteria, including the end-use and end-user of the SCOMET items, the type and sensitivity of the item, the potential risk of diversion or misuse, and the compliance with national and international laws and regulations. The applicant must demonstrate that the intended use of the SCOMET item is legitimate and complies with the provisions of the SCOMET Authorization Scheme.</p>
//         ),
//   },
// ];

// export default function ScometAuthorisation() {
//   //  const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                         <div>

//                   <h1>Special Chemicals, Organisms, Materials, Equipment and Technologies Authorisation (SCOMET Authorisation)</h1>
//             <h2>Summary of SCOMET</h2>

//                   <p>
//                       Special Chemicals, Organisms, Materials, Equipment, and Technologies (SCOMET) goods are dual-use items that can be employed in both civilian and military settings. The export of commodities on the SCOMET list is regulated by India's Foreign Trade Policy. To export SCOMET, the exporter must receive a licence from the Director General of Foreign Trade.
//                       <br />
//                       Export of Special Chemicals, Organisms, Materials, Equipment and Technologies (SCOMET), as indicated in Appendix-3 of Schedule 2 of ITC(HS) Classification of Export & Import Items, shall be governed by the specific provisions of (i) Chapter IV A of the FT(D&R) Act, 1992 as amended from time to time (ii) Sl. No. 4 & 5 of Table A and Appendix-3 of Schedule 2 of ITC(HS) Classification of Export & Import Items (iii) Para 2.16, Para 2.17, Para 2.18 of FTP and (iv) Para 2.73 -2.82 of Hand Book of Procedures, in addition to the other provisions of FTP and Handbook of Procedures governing export Authorisations.
//                   </p>
//                   </div>
//                  </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>
            
//         <Row className="g-4 align-items-start">
//                           {/* LEFT CONTENT */}
//                       <Col lg={12} xl={12}>
//                         <div>
//                   <p> Sections 5 and 14A of the FTDR Act of 1992 were used to notify the SCOMET list of products. The FTDR Act of 1992 was revised in 2010, and a new Chapter IV-A was added. This newly added chapter addresses export controls for certain products, services, and technologies, and gives the Central Government the authority to monitor and alter the list of such items, services, and technologies.</p>
//                     <p>  Appendix 3 of Schedule 2 of the ITC contains the SCOMET list (HS). The export of items on the SCOMET list is limited and requires a licence or authorisation. The SCOMET articles are divided into nine different categories:</p>
//                     <p>  i. Nuclear materials, nuclear-related other materials, equipment, and technology (Category 0)</p>
//                     <p>ii. Toxic chemical agents and other chemicals (Category 1)</p>
//                     <p>  iii. Microorganisms and Toxins (Category 2)</p>
//                     <p>  iv. Materials, Materials Processing Equipment, and Related Technologies (Category 3)</p>
//                     <p>  v. Uncontrolled nuclear-related other equipment and technologies (Category 4)</p>
//                     <p>  vi. Aerospace systems, equipment, including production and test equipment, related technology, and specially designed components and accessories thereof (Category 5).</p>
//                     <p>  vii. Munitions list (Category 6)</p>
//                     <p>  viii. Reserved (Category 7)</p>
//                     <p>  ix. Special Materials and Related Equipment, Material Processing, Electronics, Computers, Telecommunications, Information Security, Sensors and Lasers, Navigation and Avionics, Marine, Aerospace, and Propulsion (Category 8)</p>
//                     <p>  It has also been clarified that the SCOMET list includes used items, non-controlled items containing one or more controlled component(s) where the controlled component(s) is the principal element, and non-controlled items containing one or more controlled component(s) where the controlled component(s) is the principal element.</p>
                  
                  
//             <h2>Export authorization for SCOMET goods</h2>
//             <p>The exporter must submit an online application to the DGFT for the award of SCOMET Authorization, as per Trade Notice No. 11/2021-22 Dated 28.07.2021 of DGFT.</p>

//             <h2>
//                       SCOMET goods for exhibition export
//                   </h2>
//             <p>Endues or end-user certifications are not required for the export of products from the SCOMET List (other than Category 0,1 and 2) purely for the purpose of display or exhibition. The export licence will not be provided for any category or item under Categories 0, 1, or 2.</p>
//             <p>Export licences for SCOMET items for exhibition in a foreign nation are subject to a six-month reimport requirement. If the exhibitor intends to sell the item during the show abroad, the merchant must apply for an export licence. The selling of SCOMET merchandise without a valid licence is prohibited.</p>

//             <h2>
//                       SCOMET items exported from DTA to SEZ
//                   </h2>
//                   <p>The SCOMET commodities can be shipped without a permit from the Domestic Tariff Area (DTA) to the Special Economic Zone (SEZ). Suppliers must, however, disclose all SCOMET supplies from the Domestic Tariff Area to the appropriate SEZ's Development Commissioner.</p>

//             <h2>DSCOMET Items from the SEZ that can be exported to any country</h2>
//             <p>For the physical export of SCOMET commodities from a Special Economic Zone outside of India, an export authorization is required.</p>

//             <h2>Authority that License</h2>
//                   <p>he Directorate General of Foreign Trade, which is part of the Licensing Authority, issues export licences for commodities included in SCOMET Categories 1, 2, 3, 4, 5, 7, and 8.</p>
//                    <p>The Ministry of Defence is the prescribed authority for the export of items included in Category 6 of the SCOMET list, with the Department of Atomic Energy being the licencing authority for items in Category 0.</p>

//             <h2>The SCOMET Export License's Validity</h2>
//                   <p>The export licence is valid for 24 months, however it can be extended for up to one year by revalidation by the DGFT regional office with approval from DGFT Headquarters.</p>
//                  <h2>At Apex Services What We Do</h2>
//                   <p>We are the Best SCOMET Authorisation consultants in Hyderabad india, we will Provide consultation for the application needs to have permission for Export Authorisation in terms of SCOMET items which is mentioned in Appendix 3 to Schedule 2 of ITC (HS) Classifications of Export and Import items. Our professionals will guide you through the entire process of the online system, right from submitting the online application, EUCs to PDF files. The holder will also have to maintain the record for up to 5 years and here too we guide you through the process of doing and acquiring the same process. </p>
//                   </div>

//     </Col>
//             </Row>
//             </Container>
//         </section>
        

//         {/* ===== FAQ SECTION ===== */}
//          <section className="py-5 bg-light faq-section">
//           <Container>
//             <Accordion defaultActiveKey="0" className="custom-faq">
//                         {faqData.map((f, i) => (
//                           <Accordion.Item eventKey={String(i)} key={i}>
//                             <Accordion.Header>{f.q}</Accordion.Header>
//                             <Accordion.Body>{f.a}</Accordion.Body>
//                           </Accordion.Item>
//                         ))}
//                       </Accordion>
//                     </Container>
//                     </section>
//                   </div>
//                   </>
//   );
// }

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaFileAlt,
  FaShieldAlt,
  FaList,
  FaIndustry,
  FaRocket,
  FaHandsHelping
} from "react-icons/fa";
import { Accordion } from "react-bootstrap";

export default function SCOMET() {

  const faqData = [
    {
      q: "What is SCOMET?",
      a: "SCOMET refers to controlled items with dual-use (civil and strategic) applications requiring DGFT authorization before export.",
    },
    {
      q: "Who needs SCOMET license?",
      a: "Any exporter dealing with controlled chemicals, materials, technology, or equipment listed under SCOMET.",
    },
    {
      q: "Is SCOMET license mandatory?",
      a: "Yes, exporting listed items without authorization can lead to severe penalties.",
    },
    {
      q: "How long does approval take?",
      a: "Usually 30–60 days depending on product complexity and approvals.",
    },
    {
      q: "What documents are required?",
      a: "Technical details, End-Use Certificate (EUC), end-user details, and DGFT application.",
    },
  ];

  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4 align-items-start mb-4">
            <Col lg={8}>
              <h1>
                SCOMET License (Export Authorization)
              </h1>

              <p>
                SCOMET (Special Chemicals, Organisms, Materials, Equipment and Technologies)
                governs export of sensitive and dual-use items under India’s Foreign Trade Policy.
              </p>

              <p>
                These items require prior DGFT approval to ensure compliance with
                national security and international regulations.
              </p>
            </Col>

            <Col lg={4}>
              {/* Add your right-side form */}
            </Col>
          </Row>

          {/* WHAT IS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> What is SCOMET?
          </h2>

          <p>
            SCOMET includes regulated goods and technologies that have both
            civilian and strategic applications and require export authorization.
          </p>

          {/* WHY */}
          <h2 className="section-title">
            <FaShieldAlt className="icon" /> Why SCOMET Regulation Exists
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Protect national security</li>
            <li><FaCheckCircle /> Prevent misuse of sensitive technology</li>
            <li><FaCheckCircle /> Ensure compliance with global treaties</li>
          </ul>

          {/* CATEGORIES */}
          <h2 className="section-title">
            <FaList className="icon" /> Categories Covered
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Special chemicals and compounds</li>
            <li><FaCheckCircle /> Advanced materials</li>
            <li><FaCheckCircle /> Dual-use equipment</li>
            <li><FaCheckCircle /> Nuclear-related items</li>
            <li><FaCheckCircle /> Aerospace and defense items</li>
            <li><FaCheckCircle /> Information security systems</li>
          </ul>

          {/* PROCESS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Licensing Process
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Product classification under SCOMET</li>
            <li><FaCheckCircle /> Documentation preparation</li>
            <li><FaCheckCircle /> DGFT application submission</li>
            <li><FaCheckCircle /> Review by ministries</li>
            <li><FaCheckCircle /> License issuance</li>
          </ul>

          {/* BENEFITS */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Why Proper Licensing Matters
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Avoid legal penalties</li>
            <li><FaCheckCircle /> Ensure smooth exports</li>
            <li><FaCheckCircle /> Build global credibility</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            We provide complete assistance including product classification,
            documentation, DGFT filing, and coordination with authorities to
            ensure smooth and compliant export approvals.
          </p>

          {/* FAQ */}
          <h2 className="section-title mt-4">Frequently Asked Questions</h2>

          <Accordion defaultActiveKey="0" className="custom-faq">
            {faqData.map((f, i) => (
              <Accordion.Item eventKey={String(i)} key={i}>
                <Accordion.Header>{f.q}</Accordion.Header>
                <Accordion.Body>{f.a}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>

        </Container>
      </section>
    </div>
  );
}